@if (data(); as msg) {
    <project-item 
        class="d-inline-block me-2"
        [project]="msg.project"  />
    <span>not found.</span>
}
 